module.exports = __webpack_public_path__ + "assets/prev-active.a7d98475.svg";